import React from 'react';
import Quota from 'components/Tvendo/Sale/DataMaster/Quota/List.js';

export default function () {
  return <Quota />;
}
